export function isPrivateCustomer(val){
    return val && val.toString() && val.toLowerCase() === "private"
}

export const DEFAULT_CUSTOMER_TYPE = 'Private'